// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"8cea1036","283":"3b6d5537","324":"4a792320","397":"cdb7cff5","453":"821fd3de","713":"655a665f","773":"d110be5f","780":"72ac5c23","831":"cb730bae","842":"76da348b"}[chunkId] + ".chunk.js";
};